module.exports = __webpack_public_path__ + "img/ci_dorso.96685658.png";